<nav
  id="navtabs"
  class="md-tabs-1 md-card-tabs-1 card navbar navbar-light bg-faded"
>
  <ul class="text-center">
    <!-- ReceivedInvites-->
    <li
      class="nav-item active ReceivedInvites"
      id="ReceivedInvites"
      (click)="setListType($event.target)"
    >
      <a
        class="nav-link ReceivedInvites"
        [ngClass]="{ active: config.type === 'received' }"
      >
        <i
          class="icofont icofont-letterbox ReceivedInvites"
          [ngClass]="{
            'text-primary': config.type === 'received'
          }"
        ></i>
        <span class="ReceivedInvites">Received invites</span>
      </a>
    </li>

    <!-- SentInvites-->
    <li
      class="nav-item SentInvites"
      id="SentInvites"
      (click)="setListType($event.target)"
    >
      <a
        class="nav-link SentInvites"
        [ngClass]="{
          active: config.type === 'sent'
        }"
      >
        <i
          class="icofont icofont-envelope-open SentInvites"
          [ngClass]="{
            'text-primary': config.type === 'sent'
          }"
        ></i>
        <span class="SentInvites">Sent invites</span>
      </a>
    </li>
  </ul>
</nav>
